import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import styles from "./Resetcomponent.module.scss";
import { HeroImage } from "./LoginV2/HeroImage";
import logo from "../public/logo.png";
import config from "../config";
import { DotLoader } from "./common/DotLoader";

function Reset() {
  const [newpassword, setnewpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const [redirect, setredirect] = useState("");
  const [errpass, setErrpass] = useState("");
  const [loading, setloading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const token = useSelector((state) => state.token.reset);
  const handlesubmit = (event) => {
    event.preventDefault();
    console.log("Reset password");
    console.log("token", token);

    if (errpass === "error") {
      alert("password credentials do not match");
    } else if (newpassword !== confirmpassword) {
      setErrpass("conpaserr");
      //alert("password do not match");
    } else if (newpassword === "") {
      // alert("please reset your password")
    } else {
      setloading(true);
      let resok = true;
      console.log("newpassword", newpassword);
      console.log("nconfirmpassword", confirmpassword);
      fetch(`${config.devurl}/resetpassword`, {
        method: "PATCH",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({ password: newpassword, confirmpassword: confirmpassword }),
      })
        .then((res) => {
             resok = res.ok;
         return res.json()
        })
        .then((res) => {
       
          console.log("resok ", resok);
          if (resok === true) {
            setTimeout(() => {
              setloading(false);
              setredirect(true);
            }, 2000);
          } else {
            console.log("resok ", res);
            setloading(false);
            throw Error(res.error);
          }
        })
        .catch((error) => {
          setloading(false);
          setErrpass(error.message ?? "Something went wrong");
        });
    }
  };
  // Validation function for validating passwords
  const validate = () => {
    let reg = /^(?=^.{8,}$)(?=.*\d)(?=.*[!@#$%^&*]+)(?![.\n])(?=.*[a-z])(?=.*[A-Z]).*$/;
    if (!reg.test(newpassword)) {
      setErrpass("error");
    } else {
      setErrpass("");
    }
  };

  const confirm = () => {
    let reg = /^(?=^.{8,}$)(?=.*\d)(?=.*[!@#$%^&*]+)(?![.\n])(?=.*[a-z])(?=.*[A-Z]).*$/;
    if (!reg.test(newpassword)) {
      setErrpass("error");
    } else {
      if (newpassword !== confirmpassword) {
        setErrpass("conpaserr");
      } else {
        setErrpass("");
      }
    }
  };

  const renderError = () => {
    if (errpass === "error") {
      return (
        <p className={styles["error-message"]}>
          Invalid password. Must be at least 8 characters with uppercase, lowercase, number and special character.
        </p>
      );
    } else if (errpass === "conpaserr") {
      return (
        <p className={styles["error-message"]}>
          Password do not match
        </p>
      );
    } else if(errpass) {
      return <p className={styles["error-message"]}>
          {errpass}
        </p>;
    } else {
      return null;
    }
  };

  if (token) {
    if (redirect) {
      return <Redirect to="/" />;
    } else {
      return (
        <div className={styles["reset-password-container"]}>
          <div className={styles["hero-section"]}>
            <div className={styles.illustration}>
              <HeroImage />
            </div>
          </div>

          <div className={styles["form-section"]}>
            <div className={styles["form-container"]}>
              <div className={styles.logo}>
                <img
                  src={logo}
                  alt="Stepswatch logo"
                  className={styles.logoImage}
                />
              </div>

              {loading ? (
                <div className={styles["loading-container"]}>
                  <DotLoader />
                  <p className={styles["loading-text"]}>
                    Resetting your password...
                  </p>
                </div>
              ) : (
                <>
                  <h2 className={styles["welcome-title"]}>
                    Reset Password
                  </h2>
                  <p className={styles.subtitle}>
                    Enter your new password below
                  </p>

                  <form onSubmit={handlesubmit}>
                    <div className={styles["form-group"]}>
                      <label htmlFor="newpassword">
                        New Password
                      </label>
                      <div className={styles["password-input-wrapper"]}>
                        <input
                          type={showPass ? "text" : "password"}
                          id="newpassword"
                          name="newpassword"
                          placeholder="New Password"
                          onBlur={() => validate()}
                          value={newpassword}
                          onChange={(e) => setnewpassword(e.target.value)}
                          required
                        />
                        <button
                          type="button"
                          className={styles["password-toggle"]}
                          onClick={() => setShowPass(!showPass)}
                          aria-label={showPass ? "Hide password" : "Show password"}
                        >
                          {showPass ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                          )}
                        </button>
                      </div>
                      <small className={styles["help-text"]}>
                        Must be at least 8 characters with uppercase, lowercase, number and special character
                      </small>
                    </div>

                    <div className={styles["form-group"]}>
                      <label htmlFor="confirmpassword">
                        Confirm Password
                      </label>
                      <div className={styles["password-input-wrapper"]}>
                        <input
                          type={showConfirmPass ? "text" : "password"}
                          id="confirmpassword"
                          name="confirmpassword"
                          placeholder="Confirm New Password"
                          value={confirmpassword}
                          onBlur={() => confirm()}
                          onChange={(e) => setconfirmpassword(e.target.value)}
                          required
                        />
                        <button
                          type="button"
                          className={styles["password-toggle"]}
                          onClick={() => setShowConfirmPass(!showConfirmPass)}
                          aria-label={showConfirmPass ? "Hide password" : "Show password"}
                        >
                          {showConfirmPass ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                          )}
                        </button>
                      </div>
                    </div>
                    {renderError()}
                    <button
                      type="submit"
                      className={styles["reset-button"]}
                      disabled={errpass === "error" || errpass === "conpaserr" || loading}
                    >
                      Reset Password
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      );
    }
  } else {
    return <Redirect to="/" />;
  }
}
export default Reset;
